import { useState } from 'react';
import { Checkbox } from '@material-ui/core';

import { AD_CONNECT_STATUSES, HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { parseComponentVersion } from '@silverfort-nodelibs/common/utils/common';
import { List, ListItem, MenuButton, Icons } from '@silverfort/sf-components';

import styles from './AdConnectStatusRow.module.css';
import serverIcon from './Images/server.png';
import { httpGet, httpPost } from '../utils';
import { MenuItemDivider } from '../DropdownMenu/MenuItem';

const AdConnectStatusRow = ({ status, hostName, domain, version, guid, isSelected, checkAdConnect }) => {
    const isEditor = true;
    const [isActionSent, setIsActionSent] = useState(false);
    const isUnreachable = status === AD_CONNECT_STATUSES.UNREACHABLE;
    const statusClass = isUnreachable ? styles.red : styles.green;

    const sendADSyncRequest = async (isFull = true) => {
        setIsActionSent(true);
        try {
            await httpPost(
                `/settings/syncActiveDirectoryOnAdConnector/${guid}`,
                { isFull: !!isFull },
                { [HTTP_OPTIONS.HANDLE_ERRORS]: true }
            );
        } catch (err) {
            console.error(err);
        } finally {
            setIsActionSent(false);
        }
    };

    const sendLogsRequest = async () => {
        setIsActionSent(true);
        try {
            await httpGet(`/Settings/SendLogs/${guid}?isAdConnect=true`);
        } catch (err) {
            console.error(err);
        } finally {
            setIsActionSent(false);
        }
    };

    const sendDeleteAdConnectorRequest = async () => {
        setIsActionSent(true);
        try {
            await httpGet(`/Settings/DeleteAdConnector/${guid}`);
        } catch (err) {
            console.error(err);
        } finally {
            setIsActionSent(false);
        }
    };

    return (
        <div className={`${styles.row} pl-5`}>
            <div className={styles.rightSide}>
                <Checkbox
                    disableRipple={true}
                    checked={isSelected}
                    onChange={checkAdConnect}
                    onClick={(e) => e.stopPropagation()}
                    color="primary"
                    style={{
                        transform: 'scale(0.667)'
                    }}
                    className="p-0"
                />
                <div className={styles.imgContainer}>
                    <img className={styles.serverImg} src={serverIcon} alt="" />
                </div>
                <div className={styles.nameContainer}>
                    <div className={styles.hostName}>{hostName}</div>
                    <div className={styles.domain}>{domain}</div>
                </div>
            </div>

            <div className={styles.leftSide}>
                <div
                    key={`status_${guid}`}
                    className={`${styles.borderLeft} ${styles.borderRight} ${styles.statusContainer}`}>
                    <div className={`${styles.status} ${statusClass}`}>{status}</div>
                </div>
                <div key={`version_${guid}`} className={`${styles.version} ${styles.borderRight}`}>
                    {parseComponentVersion(version)}
                </div>
                <div
                    key={`actions_${guid}`}
                    className={styles.actions}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}>
                    <MenuButton
                        className={`left-[-80px] text-left`}
                        buttonStyle="PrimarySolid"
                        iconRight={isActionSent ? undefined : Icons.ChevronDown}
                        disabled={isActionSent || !isEditor}
                        text={isActionSent ? 'Sent!' : 'Actions'}
                        id={'action-dropdown' + guid}
                        content={
                            <List>
                                {isUnreachable ? (
                                    <ListItem
                                        title="Delete"
                                        onClick={sendDeleteAdConnectorRequest}
                                        disabled={!isEditor}
                                    />
                                ) : (
                                    <>
                                        <ListItem title="AD Sync" onClick={sendADSyncRequest} disabled={!isEditor} />
                                        <MenuItemDivider />
                                        <ListItem
                                            title="Quick AD Sync"
                                            onClick={() => sendADSyncRequest(false)}
                                            disabled={!isEditor}
                                        />
                                        <MenuItemDivider />
                                        <ListItem title="Send Logs" onClick={sendLogsRequest} disabled={!isEditor} />
                                    </>
                                )}
                            </List>
                        }
                    />
                </div>
            </div>
        </div>
    );
};

export default AdConnectStatusRow;
